import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Utils */
import { createToast } from 'utils/toast.js';
/** Constants */
import {
  MODIFIY_CLIENT_FORM_DATA,
  CREATE_CLIENT_FORM,
} from 'constants/clients.js';
/** Components */
import Button from 'components/Button';
import Input from 'components/Input';
import Switch from 'components/Switch';
import Loader from 'components/Loader';
/** Services */
import { updateClient, deleteClient } from 'services/clients.js';
/** Utils */
import { validateEmail } from 'utils/email.js';
/** Styles */
import styles from './PersonalData.module.scss';

const PersonalData = ({ client }) => {
  const [isLoaded, setIsLoaded] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [saveDelete, setSaveDelete] = useState(false);
  const [clientData, setClientData] = useState(MODIFIY_CLIENT_FORM_DATA);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    populateForm();
  }, []);

  const populateForm = () => {
    CREATE_CLIENT_FORM.forEach(({ id }) => {
      const input = document.querySelector(`#${id}`);
      input.value = client[id];
    });
    setClientData({
      ...clientData,
      id: client.id,
      name: client.name,
      managementId: client?.managementId ?? '',
      NIF: client.NIF,
      country: client.country,
      city: client.city,
      zipCode: client.zipCode,
      addressFirstLine: client.addressFirstLine,
      addressSecondLine: client.addressSecondLine,
      VAT: client.VAT,
    });

    if (client.email !== undefined) {
      setIsValidEmail(validateEmail(client.email));
    }
  };

  const changeHandler = ({ target: { name, value } }) => {
    setClientData({
      ...clientData,
      [name]: typeof value === 'string' ? value.trim() : value,
    });

    if (name === 'email') {
      setIsValidEmail(validateEmail(value));
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setSubmitting(true);
    updateClient(clientData)
      .then(() => {
        createToast({
          text: 'Cliente modificado con éxito',
          type: 'success',
          duration: 2500,
        });
        setSubmitting(false);
      })
      .catch(() => {
        createToast({
          text: 'Algo ha ido mal, intentalo de nuevo más tarde',
          type: 'error',
        });
        setSubmitting(false);
      });
  };

  const removeHandler = () => {
    if (saveDelete) {
      deleteClient(client.id)
        .then(({ status }) => {
          if (status === 204) {
            createToast({
              text: 'Cliente eliminado con éxito',
              type: 'success',
              duration: 2500,
            });
          }
          setIsLoaded(false);
          setTimeout(() => {
            navigate('/clientes');
          }, 500);
        })
        .catch(() => {
          createToast({
            text: 'No se ha podido eliminar el cliente, inténtalo de nuevo más tarde',
            type: 'error',
          });
        });
      return;
    }

    setSaveDelete(true);
    setTimeout(() => {
      setSaveDelete(false);
    }, 3000);
  };

  return (
    <>
      {isLoaded ? (
        <>
          <div className={styles.FiscalData}>
            <h2 className={styles.ClientDataTitle}>Datos Fiscales</h2>
            <form
              id="client-form"
              onSubmit={submitHandler}
              className={styles.FormWrapper}
            >
              {CREATE_CLIENT_FORM.map(({ id, label, type, placeholder }) => (
                <Input
                  key={id}
                  name={id}
                  placeholder={placeholder}
                  className={styles.InputAddress}
                  type={type}
                  label={label}
                  onChange={changeHandler}
                />
              ))}
              <div className={styles.ClientVAT}>
                <Switch
                  id="VAT"
                  value={client.VAT}
                  onChange={(value) =>
                    changeHandler({ target: { name: 'VAT', value } })
                  }
                >
                  IVA comunitario
                </Switch>
              </div>

              <div className={styles.ClientFormButtons}>
                <Button
                  remove
                  text={saveDelete ? 'Confirmar' : 'Eliminar'}
                  type="button"
                  click={removeHandler}
                />
                <Button update loading={submitting} text="Actualizar" />
              </div>
            </form>
          </div>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default PersonalData;
